import Feedback from "../../components/Feedback";

const FeedbackPage = () => {
  return (
    <div className="h-full overflow-y-auto p-6">
      <Feedback />
    </div>
  );
};

export default FeedbackPage;
